import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Helmet } from 'react-helmet-async';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactFlagsSelect from 'react-flags-select';
import {
  Box,
  Button,
  Grid,
  Stack
} from 'src/components';
import Avatar from 'src/components/Avatar';
import Typography from 'src/components/Typography';
import Accordion from 'src/components/Accordion';
import AccordionSummary from 'src/components/AccordionSummary';
import AccordionDetails from 'src/components/AccordionDetails';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import 'src/content/pages/Login/login.css';
import { CustomThemeContext } from 'src/theme/ThemeProvider';
import AuthSlice from "src/store/slices/Auth/AuthSlice";
import OrganizasyonSecim from "./OrganizasyonSecim";
import SnackbarUtils from "src/utils/SnackbarUtils";
import OgnLogin from "./OgnLogin";
import EImzaLogin from "./EImzaLogin";
import EImzaLoginRaporDogrulama from './RaporDogrulama';
import EImzaLoginSlice from 'src/store/slices/Auth/EImzaLoginSlice';
import DuyuruTanimSlice from '../Duyuru/DuyuruSlice/DuyuruSlice';
import KullanimKilavuzuLogin from './KullanimKilavuzuLogin';
import KullaniciGirisi from './KullaniciGirisi';
import KullaniciMetinleri from './KullaniciMetinleri';
import EmbedViewer from 'src/parts/Genel/DokumanViewer';
import { useLazyTestRehberiGetirQuery } from 'src/services/FiyatTarifesi/FiyatTarifesiApi';
const LoginAccordion = styled(Accordion)(
  ({ theme }) => `
  border-radius: ${theme.shape.borderRadius}px;
  background-color: "#fff";
`
);
const LoginAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => `
  border-radius: ${theme.shape.borderRadius}px;
  background-color: ${theme.palette.primary.main};
  min-height: 32px;
  height: 32px;
`
);
const BackGround = styled(Box)(
  ({ theme }) => `
  width: 100%;
  height: 100vh;
  position: absolute;
  background-image: url("static/images/background/background-lab.jpeg");
  background-size: cover;
  z-index: -1
`
);
const LoginForm = () => {
  const dispatch = useAppDispatch();
  const userState = useAppSelector((state) => state.userLogin);
  const userBolum = useAppSelector((state) => state.userOrganizasyon);
  const eImzaLoginState = useAppSelector(s => s.EImzaLoginState);
  const duyuruTanimState = useAppSelector(s => s.DuyuruTanimState);
  const userOrganizasyon = useAppSelector(state => state.userOrganizasyon)
  const bffSettingsConfig = useAppSelector(s => s.cache.bffSettingsConfig)
  useEffect(() => {
    if (userState.Loginkod.trim() && userState.Password.trim())
      dispatch(AuthSlice.actions.setState({
        ...userState,
        isButtonDisabled: false,
      }))
    else
      dispatch(AuthSlice.actions.setState({
        ...userState,
        isButtonDisabled: true,
      }))
  }, [userState.Loginkod, userState.Password, dispatch, userState.tabValue]);

  useEffect(() => {
    if (userState.isLoggedIn && userState.userInfo.bilgi) {
      SnackbarUtils.warning(userState.userInfo.bilgi)
    }
  }, [userOrganizasyon.data.treeKey])
 
  // useEffect(()=> {
  //   document.cookie.split(";").forEach((c) => {
  //     document.cookie = c
  //       .replace(/^ +/, "")
  //       .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  //   });
  // },[])
  
  const handleAccordion = (panel) => (event, isExpanded) => {
    dispatch(AuthSlice.actions.setState({
      ...userState,
      expanded: isExpanded ? panel : ""
    }))
  };
  const themeContext = useContext(CustomThemeContext)
  const handleLangChange = (code) => {
    i18n.changeLanguage(code);
    setLang(code);
    localStorage.setItem('lang', code);
    themeContext.setLang(code);
  };

  const [lang, setLang] = useState(
    localStorage.getItem('lang') ? localStorage.getItem('lang') : 'TR'
  );

  localStorage.setItem('lang', lang)
  const { t, i18n } = useTranslation();
  const [testRehberiOpen, setTestRehberiOpen] = useState(false)
  const [testRehberiSrc, setTestRehberiSrc] = useState("")
  const [testRehberi, testRehberiState] = useLazyTestRehberiGetirQuery()
  return userBolum.data.key > 0 ? (
    <Navigate to="/duyuru" replace />
  ) : (
    <>
      <Helmet>
        <title>{t('pages|login|title', 'Giriş Sayfası')}</title>
      </Helmet>
      <BackGround />
      <Stack direction={"row"} alignItems={"center"}>
        <Box
          sx={{
            backgroundColor: "rgba(255,255,255,0.7)",
            minHeight: "100vh",
            width: 500,
            float: "left",
            zIndex: 3,
            boxShadow: "0 0px 50px 5px rgb(0 0 0 / 50%)",
            borderRadius: "0px 2px 2px 0px"
          }}
        >
          <Grid container>
            <Grid item>
              <Grid container alignItems={"center"}>
                <Grid item xs={4}>
                  <Box
                    sx={{
                      width: "200",
                      height: 200,
                    }}>
                    <Box
                      sx={{
                        width: 200,
                        height: 200,
                        background: "linear-gradient(-45deg,transparent 50%,#48C1C4 0)",
                        position: "fixed"
                      }}
                    >

                    </Box>
                    <Avatar
                      src="static/images/logo/KurumLogoSb.png"
                      sx={{
                        width: 115,
                        height: 115,
                        p: 1,
                        filter: "brightness(0) invert(1)"

                      }}
                    >
                    </Avatar>
                  </Box>
                </Grid>
                <Grid item xs={8}>
                  <Avatar
                    src="static/images/logo/KurumLogo.png"
                    sx={{
                      width: 200,
                      height: "100%"
                    }}
                    variant="rounded"
                  >
                  </Avatar>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Typography paddingLeft={5} paddingRight={5} textAlign={"justify"}>
                {process.env.REACT_APP_DESCRIPTION} 
              </Typography>
            </Grid>
            <Grid item>
              <Box paddingLeft={10} paddingRight={10}>
                <OgnLogin />
              </Box>
            </Grid>
            {( bffSettingsConfig.eimzaGirisKapat === "H" && bffSettingsConfig.kullaniciGirisKapat === "H")  && <Grid item>
              <Box paddingLeft={10} paddingRight={10}>
                {bffSettingsConfig.kullaniciGirisKapat === "H" && <LoginAccordion
                  square
                  expanded={userState.expanded === 'panel1'}
                  onChange={handleAccordion('panel1')}
                  disableGutters
                  sx={{
                    mb: 2
                  }}
                >
                  <LoginAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography width={"40%"}></Typography>
                    <Typography
                      sx={{
                        color: "#fff"
                      }}
                      variant="button"
                    >
                      
                      {userState.tabValue === "2" ? t('pages|login|sifreDegisim', 'Yeni Şifre Oluştur')
                       : t('pages|login|userLogin', 'Kullanıcı Girişi')
                      }
                    </Typography>
                  </LoginAccordionSummary>
                  <AccordionDetails sx={{
                    pt: 2,
                    pb: 1
                  }}>
                    {userState.expanded === 'panel1' && <Grid container justifyContent={"right"}>
                      <KullaniciGirisi />
                    </Grid>}
                  </AccordionDetails>
                </LoginAccordion>}
                {bffSettingsConfig.eimzaGirisKapat === "H" && <LoginAccordion
                  expanded={userState.expanded === 'panel2'}
                  onChange={handleAccordion('panel2')}
                  disableGutters
                >
                  <LoginAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography width={"41%"}></Typography>
                    <Typography
                      sx={{
                        color: "#fff"
                      }}
                      variant="button"
                    >
                      {t('pages|login|eImzaGris', 'E-İmza Giriş')}
                    </Typography>
                  </LoginAccordionSummary>
                  <AccordionDetails sx={{
                    pt: 2
                  }}>
                    {userState.expanded === 'panel2' && <EImzaLogin />}
                  </AccordionDetails>
                </LoginAccordion>}
              </Box>
            </Grid>}
            <Grid item>
              <Box paddingLeft={10} paddingRight={10}>
                <Grid container justifyContent={"flex-end"} alignItems={"center"}>
                  <Grid item>
                    <Button
                      color="warning"
                      loading={testRehberiState.isFetching}
                      onClick={(e) =>
                        testRehberi().unwrap()
                          .then(res => {
                            setTestRehberiSrc("data:application/pdf;base64," + res)
                            setTestRehberiOpen(true)
                          })
                      }
                    >{t("pages|login|testRehberi", "Test Rehberi")}</Button>
                  </Grid>
                  <Grid item>
                    <Button
                      color="warning"
                      onClick={(e) => {
                        dispatch(EImzaLoginSlice.actions.setOpen(true))
                      }}
                    // sx={{
                    //     backgroundColor: "#48C1C4"
                    // }}
                    >{t("pages|login|rapor Doğrulama", "Lbys Rapor Doğrulama")}</Button>
                  </Grid>
                  <Grid item xs={6}>
                    {"v" + process.env.REACT_APP_VERSION}
                  </Grid>
                  <Grid item xs={6}>
                    <ReactFlagsSelect
                      countries={['TR', 'US']}
                      customLabels={{
                        TR: t('pages|login|langs|turkish', 'Türkçe'),
                        US: t('pages|login|langs|english', 'İngilizce'),
                      }}
                      placeholder={t('pages|login|langs|select_language', 'Dil Seçin')}
                      onSelect={(code) => {
                        handleLangChange(code);
                      }}
                      selected={lang}
                      showSelectedLabel={true}
                      showOptionLabel={true}
                      className="flag-select-container"
                      selectButtonClassName="flagsSelect"
                    />
                  </Grid>
                  <Grid item>
                    <KullaniciMetinleri />
                  </Grid>
                </Grid>
              </Box>
            </Grid >
          </Grid>
        </Box>
        {/* <Box sx={{
          width: "calc(100% - 500px)",
          pt: 2,
          pb: 2
        }}>
          <Typography sx={{backgroundColor:"rgba(255,255,255,0.3)"}} color="white"
            variant='h1' padding={10} textAlign={"justify"}>{process.env.REACT_APP_DESCRIPTION}</Typography>
        </Box> */}
      </Stack>
      {!userState.aydinlatmaMetniOpen && <OrganizasyonSecim menuden={false} />}

      {eImzaLoginState.open && (
        <EImzaLoginRaporDogrulama
          open={eImzaLoginState.open}
          onClose={() => { dispatch(EImzaLoginSlice.actions.setOpen(false)) }}
          fullWidth={true}
          maxWidth="md"
          height={500}
        />
      )}
      {duyuruTanimState.openLoginDialog && (
        <KullanimKilavuzuLogin
          open={duyuruTanimState.openLoginDialog}
          fullWidth={true}
          maxWidth="md"
          closeHandler={() => {
            dispatch(DuyuruTanimSlice.actions.setOpenLoginDialog(false));
          }}
        />
      )}
      {testRehberiOpen && (
        <EmbedViewer
          open={testRehberiOpen}
          onClose={() => setTestRehberiOpen(false)}
          title={t("pages|login|testRehberi", "Test Rehberi")}
          src={testRehberiSrc}
        />
      )}
    </>
  );
};

export default LoginForm;
